const HEADSPACE_GLOBAL_ENVIRONMENT_KEY = 'HEADSPACE_APP_CONFIG';

export function getConfig(): Config {
    return (window as { [key: string]: any })[HEADSPACE_GLOBAL_ENVIRONMENT_KEY] as unknown as Config;
}

export interface Config {
    disscussionsApiBaseUrl: string;
    apiBaseUrl: string;
    okta: {
        issuer: string;
        clientId: string;
    }
}
